import type { Template } from "@/types";

export const PO_02_H0_V2: Template[] = [

    {
        id: "po-02-h0v2-01",
        name: "PO 01 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 626, height: 783, rotation: 0, imageRotation: 0 },
            { id: "2", x: 714, y: 75, width: 450, height: 634, rotation: 0, imageRotation: 0 }
        ],
    },


    {
        id: "po-02-h0v2-02",
        name: "PO 02 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 87, y: 75, width: 450, height: 634, rotation: 0, imageRotation: 0 },
            { id: "2", x: 626, y: 0, width: 626, height: 783, rotation: 0, imageRotation: 0 },      
        ],
    },

    {
        id: "po-02-h0v2-03",
        name: "PO 03 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 713, y: 74, width: 450, height: 634, rotation: 0, imageRotation: 0 },
            { id: "2", x: 87, y: 74, width: 450, height: 634, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-04",
        name: "PO 04 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 230, y: 116, width: 391, height: 551, rotation: 0, imageRotation: 0 },
            { id: "2", x: 631, y: 116, width: 391, height: 551, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-05",
        name: "PO 05 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 35, y: 0, width: 555, height: 783, rotation: 0, imageRotation: 0 },
            { id: "2", x: 662, y: 0, width: 555, height: 783, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-06",
        name: "PO 06 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 35, y: 0, width: 555, height: 783, rotation: 0, imageRotation: 0 },
            { id: "2", x: 773, y: 156, width: 333, height: 469, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-07",
        name: "PO 07 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 75, y: 56, width: 476, height: 672, rotation: 0, imageRotation: 0 },
            { id: "2", x: 773, y: 156, width: 333, height: 469, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-08",
        name: "PO 08 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 118, y: 116, width: 391, height: 551, rotation: 0, imageRotation: 0 },
            { id: "2", x: 744, y: 116, width: 391, height: 551, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-09",
        name: "PO 09 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 662, y: 0, width: 555, height: 783, rotation: 0, imageRotation: 0 },
            { id: "2", x: 147, y: 156, width: 333, height: 469, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-10",
        name: "PO 10 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 702, y: 56, width: 476, height: 672, rotation: 0, imageRotation: 0 },
            { id: "2", x: 147, y: 156, width: 333, height: 469, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-11",
        name: "PO 11 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_11.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 101, y: 92, width: 425, height: 598, rotation: 0, imageRotation: 0 },
            { id: "2", x: 727, y: 92, width: 425, height: 598, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-12",
        name: "PO 12 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_12.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 35, y: 31, width: 556, height: 722, rotation: 0, imageRotation: 0 },
            { id: "2", x: 661, y: 31, width: 556, height: 722, rotation: 0, imageRotation: 0 }
        ],
    }
];